import { inject as v, computed as z, toValue as r, onMounted as S, watch as C, onBeforeUnmount as h } from "vue";
import { c as x } from "../dynamicScrollerMeasurement-Cq5NQLJa.js";
function _(i, A, c) {
  const R = v("vscrollMeasurementContext"), n = v("vscrollAnchorRegistry", null), u = z(() => {
    const e = r(i).el;
    return r(A ?? e);
  }), p = {
    onResize: (e) => {
      var o;
      return (o = (c == null ? void 0 : c.onResize) ?? r(i).onResize) == null ? void 0 : o(e);
    }
  }, s = z(() => r(
    r(i).enabled ?? !0
  )), t = x(i, u, R, p);
  let l = !1;
  function d() {
    l || (t.mount(), l = !0);
  }
  function a() {
    l && (t.unmount(), l = !1);
  }
  return S(() => {
    s.value && d();
  }), C(s, (e) => {
    if (e)
      d();
    else {
      const o = u.value;
      n && o && n.delete(o), a();
    }
  }), n && C(
    [t.id, t.finalActive, u, s],
    ([e, o, f, y], [I, g, m]) => {
      m && m !== f && n.delete(m), y && f && n.set(f, {
        active: o,
        id: e
      });
    },
    {
      immediate: !0
    }
  ), h(() => {
    const e = u.value;
    n && e && n.delete(e), a();
  }), {
    id: t.id,
    size: t.size,
    finalActive: t.finalActive,
    updateSize: t.updateSize
  };
}
export {
  _ as useDynamicScrollerItem
};
//# sourceMappingURL=useDynamicScrollerItem.js.map
